import {
  AnimationClassNames,
  mergeStyles,
  Spinner,
  Stack,
  Text,
} from "@fluentui/react";
import ReactDOM from "react-dom";

import { apiBaseUrl } from "../utils/api";

let focused = true;

const mountDiv = document.createElement("div");
document.body.prepend(mountDiv);

const contentClass = mergeStyles([
  {
    marginTop: "44px", // navbar
    marginBottom: "-44px", //
    backgroundColor: "orange",
    color: "#fff",
    lineHeight: "50px",
    padding: "0 20px",
  },
  AnimationClassNames.scaleUpIn100,
]);

const SystemUnreachable = (
  <div className={contentClass}>
    <Stack horizontal horizontalAlign="center" tokens={{ childrenGap: 10 }}>
      <Spinner />
      <Text variant="large" style={{ color: "#fff" }}>
        Bağlantıda sorun yaşanıyor. Yeni işlem yapmayın.
      </Text>
    </Stack>
  </div>
);

const mount = () => ReactDOM.render(SystemUnreachable, mountDiv);

const makeRequest = () => {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 5000);

  return fetch(apiBaseUrl + "/ping", { signal: controller.signal }).then(
    (res) => {
      clearTimeout(timeout);
      return res;
    }
  );
};

const check = () => {
  if (!focused) {
    return;
  }

  makeRequest()
    .then((res) => {
      if (res.status === 200) {
        if (mountDiv) ReactDOM.unmountComponentAtNode(mountDiv);
      } else {
        mount();
      }
    })
    .catch((err) => {
      console.error(err);
      mount();
    });
};

if (window.location.pathname !== "/render-pdf") {
  window.onfocus = () => {
    focused = true;
    check();
  };

  window.onblur = () => {
    focused = false;
  };

  check();
  setInterval(check, 5 * 60 * 1000);
}
